import { useContext, createContext } from "react";
import { BrandConfig } from "utils/v2/BrandsConfig/types/BrandConfig";
import { Logo, LogoDark, WEGALogoDark, WEGALogo } from "assets/images";
import { getTheme } from "utils/v2/theme";

export const defaultBrandsConfig: BrandConfig = {
  title: "Lenkrad",
  logo: getTheme() === "dark" ? LogoDark : Logo,
  persianTitle: "لنکراد",
  linkTags: [
    { rel: "apple-touch-icon", href: "/lenkrad/apple-touch-icon.png?v=4" },
    { rel: "icon", href: "/lenkrad/favicon.ico?v=4" },
    { rel: "icon", href: "/lenkrad/favicon=32x32.png?v=4", sizes: "32x32" },
    { rel: "icon", href: "/lenkrad/favicon=16x16.png?v=4", sizes: "16x16" },
    { rel: "manifest", href: "/lenkrad/manifest.json?v=4" },
    { rel: "safari-pinned-tab", href: "/lenkrad/safari-pinned-tab.svg?v=4" },
  ],
  metaTags: [
    { name: "msapplication-config", content: "/lenkrad/browserconfig.xml" },
  ],
  website: "LENKRAD.IR",
  overrideLogo: LogoDark,
  secondOverrideLogo: Logo,
};
export const brandsConfig: Record<string, BrandConfig> = {
  "app.lenkrad.co": {
    title: "Lenkrad",
    logo: getTheme() === "dark" ? LogoDark : Logo,
    persianTitle: "لنکراد",
    linkTags: [
      { rel: "apple-touch-icon", href: "/lenkrad/apple-touch-icon.png?v=4" },
      { rel: "icon", href: "/lenkrad/favicon.ico?v=4" },
      { rel: "icon", href: "/lenkrad/favicon-32x32.png?v=4", sizes: "32x32" },
      { rel: "icon", href: "/lenkrad/favicon-16x16.png?v=4", sizes: "16x16" },
      { rel: "manifest", href: "/lenkrad/manifest.json?v=4" },
      { rel: "safari-pinned-tab", href: "/lenkrad/safari-pinned-tab.svg?v=4" },
    ],
    metaTags: [
      { name: "msapplication-config", content: "/lenkrad/browserconfig.xml" },
    ],
    website: "LENKRAD.IR",
    overrideLogo: LogoDark,
    secondOverrideLogo: Logo,
  },
  "stg.radlenk.com": {
    title: "Lenkrad",
    logo: getTheme() === "dark" ? LogoDark : Logo,
    persianTitle: "لنکراد",
    linkTags: [
      { rel: "apple-touch-icon", href: "/lenkrad/apple-touch-icon.png?v=4" },
      { rel: "icon", href: "/lenkrad/favicon.ico?v=4" },
      { rel: "icon", href: "/lenkrad/favicon-32x32.png?v=4", sizes: "32x32" },
      { rel: "icon", href: "/lenkrad/favicon-16x16.png?v=4", sizes: "16x16" },
      { rel: "manifest", href: "/lenkrad/manifest.json?v=4" },
      { rel: "safari-pinned-tab", href: "/lenkrad/safari-pinned-tab.svg?v=4" },
    ],
    metaTags: [
      { name: "msapplication-config", content: "/lenkrad/browserconfig.xml" },
    ],
    website: "LENKRAD.IR",
    overrideLogo: LogoDark,
    secondOverrideLogo: Logo,
  },
  "test2.radlenk.com": {
    title: "Lenkrad",
    logo: getTheme() === "dark" ? LogoDark : Logo,
    persianTitle: "لنکراد",
    linkTags: [
      { rel: "apple-touch-icon", href: "/lenkrad/apple-touch-icon.png?v=4" },
      { rel: "icon", href: "/lenkrad/favicon-32x32.png?v=4", sizes: "32x32" },
      { rel: "icon", href: "/lenkrad/favicon-16x16.png?v=4", sizes: "16x16" },
      { rel: "manifest", href: "/lenkrad/manifest.json?v=4" },
      { rel: "safari-pinned-tab", href: "/lenkrad/safari-pinned-tab.svg?v=4" },
      { rel: "icon", href: "/lenkrad/favicon.ico?v=4" },
    ],
    metaTags: [
      { name: "msapplication-config", content: "/lenkrad/browserconfig.xml" },
    ],
    website: "LENKRAD.IR",
    overrideLogo: LogoDark,
    secondOverrideLogo: Logo,
  },
  "app.wegagps.com": {
    title: "WEGA",
    logo: getTheme() === "dark" ? WEGALogoDark : WEGALogo,
    persianTitle: "WEGA",
    linkTags: [
      { rel: "apple-touch-icon", href: "/wega/apple-touch-icon.png?v=4" },
      {
        rel: "apple-touch-icon",
        sizes: "57x57",
        href: "/wega/apple-touch-icon-57x57.png?v=4",
      },
      {
        rel: "apple-touch-icon",
        sizes: "72x72",
        href: "/wega/apple-touch-icon-72x72.png?v=4",
      },
      {
        rel: "apple-touch-icon",
        sizes: "76x76",
        href: "/wega/apple-touch-icon-76x76.png?v=4",
      },
      {
        rel: "apple-touch-icon",
        sizes: "114x114",
        href: "/wega/apple-touch-icon-114x114.png?v=4",
      },
      {
        rel: "apple-touch-icon",
        sizes: "120x120",
        href: "/wega/apple-touch-icon-120x120.png?v=4",
      },
      {
        rel: "apple-touch-icon",
        sizes: "144x144",
        href: "/wega/apple-touch-icon-144x144.png?v=4",
      },
      {
        rel: "apple-touch-icon",
        sizes: "152x152",
        href: "/wega/apple-touch-icon-152x152.png?v=4",
      },
      {
        rel: "apple-touch-icon",
        sizes: "180x180",
        href: "/wega/apple-touch-icon-180x180.png?v=4",
      },
      { rel: "icon", href: "/wega/favicon.ico?v=4" },
      { rel: "icon", href: "/wega/favicon-32x32.png?v=4", sizes: "32x32" },
      { rel: "icon", href: "/wega/favicon-16x16.png?v=4", sizes: "16x16" },
      { rel: "manifest", href: "/wega/manifest.json?v=4" },
      {
        rel: "safari-pinned-tab",
        href: "/wega/safari-pinned-tab.png?v=4",
      },
    ],
    metaTags: [
      { name: "msapplication-config", content: "/wega/browserconfig.xml" },
    ],
    website: "wegagps.com",
    overrideLogo: WEGALogoDark,
    secondOverrideLogo: WEGALogo,
  },
  "test3.radlenk.com": {
    title: "WEGA",
    logo: getTheme() === "dark" ? WEGALogoDark : WEGALogo,
    persianTitle: "WEGA",
    linkTags: [
      { rel: "apple-touch-icon", href: "/wega/apple-touch-icon.png?v=4" },
      {
        rel: "apple-touch-icon",
        sizes: "57x57",
        href: "/wega/apple-touch-icon-57x57.png?v=4",
      },
      {
        rel: "apple-touch-icon",
        sizes: "72x72",
        href: "/wega/apple-touch-icon-72x72.png?v=4",
      },
      {
        rel: "apple-touch-icon",
        sizes: "76x76",
        href: "/wega/apple-touch-icon-76x76.png?v=4",
      },
      {
        rel: "apple-touch-icon",
        sizes: "114x114",
        href: "/wega/apple-touch-icon-114x114.png?v=4",
      },
      {
        rel: "apple-touch-icon",
        sizes: "120x120",
        href: "/wega/apple-touch-icon-120x120.png?v=4",
      },
      {
        rel: "apple-touch-icon",
        sizes: "144x144",
        href: "/wega/apple-touch-icon-144x144.png?v=4",
      },
      {
        rel: "apple-touch-icon",
        sizes: "152x152",
        href: "/wega/apple-touch-icon-152x152.png?v=4",
      },
      {
        rel: "apple-touch-icon",
        sizes: "180x180",
        href: "/wega/apple-touch-icon-180x180.png?v=4",
      },
      { rel: "icon", href: "/wega/favicon.ico?v=4" },
      { rel: "icon", href: "/wega/favicon-32x32.png?v=4", sizes: "32x32" },
      { rel: "icon", href: "/wega/favicon-16x16.png?v=4", sizes: "16x16" },
      { rel: "manifest", href: "/wega/manifest.json?v=4" },
      {
        rel: "safari-pinned-tab",
        href: "/wega/safari-pinned-tab.png?v=4",
      },
    ],
    metaTags: [
      { name: "msapplication-config", content: "/wega/browserconfig.xml" },
    ],
    website: "wegagps.com",
    overrideLogo: WEGALogoDark,
    secondOverrideLogo: WEGALogo,
  },
  "wega-webapp-staging.darkube.app": {
    title: "WEGA",
    logo: getTheme() === "dark" ? WEGALogoDark : WEGALogo,
    persianTitle: "WEGA",
    linkTags: [
      { rel: "apple-touch-icon", href: "/wega/apple-touch-icon.png?v=4" },
      {
        rel: "apple-touch-icon",
        sizes: "57x57",
        href: "/wega/apple-touch-icon-57x57.png?v=4",
      },
      {
        rel: "apple-touch-icon",
        sizes: "72x72",
        href: "/wega/apple-touch-icon-72x72.png?v=4",
      },
      {
        rel: "apple-touch-icon",
        sizes: "76x76",
        href: "/wega/apple-touch-icon-76x76.png?v=4",
      },
      {
        rel: "apple-touch-icon",
        sizes: "114x114",
        href: "/wega/apple-touch-icon-114x114.png?v=4",
      },
      {
        rel: "apple-touch-icon",
        sizes: "120x120",
        href: "/wega/apple-touch-icon-120x120.png?v=4",
      },
      {
        rel: "apple-touch-icon",
        sizes: "144x144",
        href: "/wega/apple-touch-icon-144x144.png?v=4",
      },
      {
        rel: "apple-touch-icon",
        sizes: "152x152",
        href: "/wega/apple-touch-icon-152x152.png?v=4",
      },
      {
        rel: "apple-touch-icon",
        sizes: "180x180",
        href: "/wega/apple-touch-icon-180x180.png?v=4",
      },
      { rel: "icon", href: "/wega/favicon.ico?v=4" },
      { rel: "icon", href: "/wega/favicon-32x32.png?v=4", sizes: "32x32" },
      { rel: "icon", href: "/wega/favicon-16x16.png?v=4", sizes: "16x16" },
      { rel: "manifest", href: "/wega/manifest.json?v=4" },
      {
        rel: "safari-pinned-tab",
        href: "/wega/safari-pinned-tab.png?v=4",
      },
    ],
    metaTags: [
      { name: "msapplication-config", content: "/wega/browserconfig.xml" },
    ],
    website: "wegagps.com",
    overrideLogo: WEGALogoDark,
    secondOverrideLogo: WEGALogo,
  },
};

export const BrandsConfigContext =
  createContext<BrandConfig>(defaultBrandsConfig);

export const useBrandsConfig = () => useContext(BrandsConfigContext);
